import React, { useState, useRef, useEffect } from 'react';
import {  Button, Box, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup'
import symptomHandler from '../../../../utilities/symptomHandler';
import RadioButton from '../../symptoms/Symptom Modal/radiobutton';
import CheckboxGroup from '../../symptoms/Symptom Modal/checkboxgroup';
import InputField from '../../symptoms/Symptom Modal/inputfield';
import TextArea from '../../symptoms/Symptom Modal/textarea';
import DropDown from '../../symptoms/Symptom Modal/dropdown';
import exceptionalRdcquestions from '../../../../utilities/clinic questions/exceptionalrdcQuestions';
import '../../../../css/report.css'
import reportUtils from '../../../../utilities/report/reportutils';

function ExceptionalFormQuestions(props){

  const formValues=useRef()
  const [newValues,setNewValues]=useState()
  const [formQuestions, setFormQuestions]=useState()
  const initialValues= symptomHandler.initialValuesBuilder(exceptionalRdcquestions)
 const validationSchema=Yup.object(reportUtils.buildValidationsSchema(exceptionalRdcquestions))
 

 

  const onClick=()=>
    {
    const setVals=()=>(setNewValues(formValues.current.values))// allows time for react to update state (tried a useEffect but didn't work)
    const delay=()=> setTimeout(setVals,100)
    delay()
    clearTimeout(delay)
    }

   
   const onSubmit=(values,errors)=>
     {
      if (values.Hospital_where_investigation_performed === "Other")
        {
        values.Hospital_where_investigation_performed = values.Where_was_it_performed
        }
      props.setFormValues(values)
     }
 
   useEffect(()=>{
    let localFormQuestions=exceptionalRdcquestions.map((symptom, index)=>
      { (symptom.hasOwnProperty("Conditional") ? symptom["show"]=false : symptom["show"]=true)
   
        //label: 'When present', controlType: 'radio button', options: Array(2)}
        symptom["name"]=symptom.label.replaceAll(" ","_")
        if (symptom.hasOwnProperty("Conditional") && newValues !== undefined)
          {
           let conditional=symptom.Conditional 
            let findConditional=(symptom["Conditional"][0]).replaceAll(" ", "_")
           let controlItem=newValues[findConditional]
          if (!conditional[1].includes(controlItem))
          {
            symptom["show"]=false
          }
          else {
            symptom["show"]=true
            if (symptom.Conditional[2]  && symptom.Conditional[2] === "Required")
              {
               symptom.required=true 
              }
          } 
        }

   switch(symptom["controlType"])
      {
        case "radio button":
          symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
         return (<Grid item xs={12} sm={6} key={index} className={(symptom.show ? "modalInputBox" : "hidden")}> <RadioButton  symptom={symptom}   onClick={onClick} key={symptom.name} /> </Grid>)
  
        case "number":
        return (<Grid item xs={12} sm={6} key={index} className={(symptom.show ? "modalInputBox" : "hidden")}> <InputField type={"number"} symptom ={symptom} min={"0"} key={0} /> </Grid>)
  
        case "text":
         return (<Grid item xs={12} sm={6} key={index}className={(symptom.show ? "modalInputBox" : "hidden")}> <InputField type={"text"} symptom ={symptom}  key={index} /> </Grid>)
  
        case "textarea":
      return (<Grid item xs={12} sm={6} key={index}className={(symptom.show ? "modalInputBox" : "hidden")}> <TextArea  symptom ={symptom}  key={index} /> </Grid>)
        
        case "dropdown": 
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "dropdown")
        return(<Grid item xs={12} sm={6} key={index} className={(symptom.show ? "modalInputBox" : "hidden")}> <DropDown  symptom ={symptom}  key={index} /> </Grid>)
  
        case "checkbox group":
          let gridSize = 6
          if (symptom.options.length >6)
            {gridSize = 12} 
          symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
          return (<Grid item  xs={12} sm={gridSize} key={index}> <CheckboxGroup symptom={symptom}  key={index} /> </Grid>)
  
        case "date": // still has problems with size of box on form and date format in story!
        return (<Grid item xs={12} sm={6} key={index} className={(symptom.show ? "modalInputBox" : "hidden")}> <InputField type={"date"} symptom ={symptom}  key={index} /> </Grid>)
  
        default:{return(<></>)}
   }})
  setFormQuestions(localFormQuestions)},[newValues])
   

  return( <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          innerRef={formValues}
          >
         <Form>  
          <Box>
        <Grid container>
          {formQuestions} <Button sx={{ m: 1 }} variant='contained' size="small" type='submit'>Submit</Button>
          </Grid>
         </Box>
          </Form>
        </Formik>
  
  )
}


export default ExceptionalFormQuestions